import React, {useState} from "react";
import {Form, Input, Modal} from "antd";
import {useFormik} from "formik";
import * as yup from "yup";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../../hooks/useStore";
import _ from "lodash";
export const UpdateEquipmentTypeModal = ({
    visibility,
    equipmentType,
    recall = () => {},
    onOk = () => {},
    onCancel = () => {},
    changeVisibility = () => {}
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    const handleCancel = () => {
        changeVisibility(false);
        onCancel();
    };

    const formik = useFormik({
        initialValues: {name: equipmentType?.name || ""},
        validationSchema: yup.object().shape({
            name: yup.string().required(t("validation.required", {ns: "common"}))
        }),
        onSubmit: async values => {
            const payload = {
                equipmentType: {
                    _id: equipmentType?._id,
                    name: values.name
                }
            };
            try {
                const response = await stores.equipmentStore.updateEquipmentType(payload);
                if (response) {
                    recall();
                    changeVisibility(false);
                    resetForm();
                    onOk();
                }
            } catch (e) {}
        },
        enableReinitialize: true
    });

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        resetForm,
        setFieldValue
    } = formik;

    return (
        <Modal
            title={"Ekipman Tipi Güncelle"}
            confirmLoading={isSubmitting}
            visible={Boolean(equipmentType) && visibility}
            onOk={handleSubmit}
            onCancel={handleCancel}
            okText="Güncelle"
            cancelText="İptal"
        >
            <Form autoComplete="off" labelCol={{span: 24}} wrapperCol={{span: 24}}>
                <Form.Item
                    label={"Ekipman Tipi"}
                    validateStatus={errors.name && touched.name ? "error" : "success"}
                    help={errors.name && touched.name ? errors.name : null}
                >
                    <Input
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        placeholder={"Kask, yelek vb."}
                        autoFocus
                        onPressEnter={handleSubmit}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
